"use client";

import { useEffect } from "react";
import { useLanguage } from "@/lib/useLanguage";

/**
 * Syncs the document html lang attribute with the current language selection.
 * Renders nothing; runs only on the client.
 */
export function HtmlLangSync() {
  const { language } = useLanguage();

  useEffect(() => {
    if (typeof document === "undefined" || !document.documentElement) return;
    const path = window.location.pathname.replace(/\/+$/, "") || "/";
    // /press owns its own lang (Catalan by default) and must not follow the site cookie.
    if (path === "/press") return;
    document.documentElement.lang = language;
  }, [language]);

  return null;
}
